import React from "react";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import { Box, Button, Container, Flex, Heading, HStack } from "@chakra-ui/react";
import { EmailIcon } from "@chakra-ui/icons";
import { ADMIN_TOKEN_KEY } from "../../connection/adminApi";

/** Every page of the console, so a new tool only has to be added here. */
const NAV = [
  { to: "/admin", label: "Stores", exact: true },
  { to: "/admin/mail", label: "Mail", icon: <EmailIcon /> },
];

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (item) =>
    item.exact ? pathname === item.to : pathname.startsWith(item.to);

  const signOut = () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);

    // Unsent mail drafts hold the operator's own words and the addresses they
    // were writing to; they must not be waiting for whoever signs in next.
    Object.keys(localStorage)
      .filter((key) => key.startsWith("storkplus.admin.mail."))
      .forEach((key) => localStorage.removeItem(key));

    navigate("/admin/login", { replace: true });
  };

  return (
    /* The console is operator tooling and stays LTR even for an Arabic UI. */
    <Box dir="ltr" minH="100vh">
      <Box bg="white" borderBottomWidth="1px" py={3} mb={6}>
        <Container maxW="7xl">
          <Flex align="center" gap={4}>
            <Heading size="sm" as={RouterLink} to="/admin">
              StorkPlus operations
            </Heading>

            <HStack spacing={1}>
              {NAV.map((item) => (
                <Button
                  key={item.to}
                  as={RouterLink}
                  to={item.to}
                  size="sm"
                  leftIcon={item.icon}
                  variant={isActive(item) ? "solid" : "ghost"}
                  colorScheme={isActive(item) ? "blue" : "gray"}
                >
                  {item.label}
                </Button>
              ))}
            </HStack>

            <Box flex="1" />
            <Button size="sm" variant="outline" onClick={signOut}>
              Sign out
            </Button>
          </Flex>
        </Container>
      </Box>

      <Container maxW="7xl" pb={12}>
        {children}
      </Container>
    </Box>
  );
};

export default AdminLayout;
